import {merge} from 'd3-array';
import {nest} from 'd3-collection';
import {hierarchy} from 'd3-hierarchy';
import interval from '../../modules/interval';
import {dateComparator, comparator, summarize} from '../../modules/transform';

function dimension(dim, nested) {
  if (dim.interval) {
    let intr = interval[dim.interval];
    nested.key(d => intr(d[dim.field]));
  } else if (dim.format) { //FIXME: format이 있는 경우를 날짜로 본다. 후에는 숫자 포맷 일 수도 있으므로 수정 필요
    let f = dim.format;
    nested.key(d => f(d[dim.field]));
  } else {
    nested.key(d => d[dim.field]) 
  }
  if(!dim.interval && (dim.order === 'ascending'  || dim.order === 'descending')) {
    nested.sortKeys(comparator(dim.order, dim.orderList));
  }
  return nested;
}

function dateKey (result, reverse, preFormat) {
  let dimensions = this.dimensions();
  let currentLevel = result;
  for (let i = 0 ; i < dimensions.length ; i++) {
    let dim = reverse ? dimensions[dimensions.length - 1 - i] : dimensions[i] ;
    if (dim.interval) {
      currentLevel.forEach(d => {
        d.key = new Date(d.key)
      });
      currentLevel.sort(dateComparator(dim.order, 'key'));
      if (preFormat && dim.format) {
        currentLevel.forEach(d => {
          d.key = dim.format(d.key);
        });
      }
    }
    if (i < dimensions.length -1) currentLevel = merge(result.map(d => d.values));
  }
  return result;
}
function aggregate (reverse = false, rollup = true, singleValue = false, preFormat = false, useHierarchy = true) {
  let data = this.data();
  let dimensions = this.dimensions();
  let measures = this.measures();
  let nested = nest();
  for (let i = 0 ; i < dimensions.length ; i++) {
    let dim = reverse ? dimensions[dimensions.length - 1 - i] : dimensions[i] ;
    dimension(dim, nested);
  }
  if(!rollup) {
    let result = dateKey.call(this, nested.entries(data), reverse, preFormat);
    return useHierarchy ? hierarchy({values:result}, function(d){return d.values;}).children : result;
  }
  nested.rollup(values => {
    let result = {};
    if (measures.length === 1 && singleValue) {
      let m = measures[0];
      return  summarize[m.op](values, d => d[m.field]); 
    } else {
      measures.forEach(m => {
        result[m.field + '-' + m.op] = summarize[m.op](values, d => d[m.field]); //결과 field 이름은 field-op 형태
      });
      return result;
    }
  });
  let result = nested.entries(data);
  dateKey.call(this, result, reverse, preFormat);
  
  return useHierarchy ? hierarchy({values:result}, function(d){return d.values;}).children : result;
}

export default aggregate;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/aggregate.js